'use client';
import { useEffect } from 'react';

export default function ServiceWorkerRegistration() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!('serviceWorker' in navigator)) return;

    let registration: ServiceWorkerRegistration | null = null;
    let updateInterval: ReturnType<typeof setInterval> | null = null;

    const registerSW = async () => {
      try {
        registration = await navigator.serviceWorker.register('/sw.js', { scope: '/' });

        // Check for updates every 30 minutes
        updateInterval = setInterval(() => {
          registration?.update().catch(() => {});
        }, 30 * 60 * 1000);

        // Also check when tab becomes visible again
        const onVisibilityChange = () => {
          if (document.visibilityState === 'visible') {
            registration?.update().catch(() => {});
          }
        };
        document.addEventListener('visibilitychange', onVisibilityChange);

        // Verify SW is alive with a PING
        if (navigator.serviceWorker.controller) {
          const channel = new MessageChannel();
          channel.port1.onmessage = (e) => {
            if (e.data?.type === 'PONG') {
              console.log('[SW] Active version:', e.data.version);
            }
          };
          navigator.serviceWorker.controller.postMessage({ type: 'PING' }, [channel.port2]);
        }
      } catch (error) {
        console.error('[SW] Registration failed:', error);
      }
    };

    // Register after page load to not block rendering
    if (document.readyState === 'complete') {
      registerSW();
    } else {
      window.addEventListener('load', registerSW, { once: true });
    }

    return () => {
      if (updateInterval) clearInterval(updateInterval);
    };
  }, []);

  return null;
}
